import { Controller } from "stimulus";

export default class extends Controller {

  static targets = [];

  connect() {
    console.log("checkout gifts");
  }

  unselectOtherGifts(e) {
    console.log("TEST unselect");
    
    var customProductId = e.target.dataset.customProductId;
    var checkoutModal = document.querySelector("#checkout_modal");
    var giftsStep = checkoutModal.querySelector("#gift_products_selection_step");
 
    var numberOfSelectableGifts = giftsStep.dataset.selectableGifts;
    

    console.log(numberOfSelectableGifts);

    var checkedCheckboxes = giftsStep.querySelectorAll("input[name=selected_product]:checked").length

    console.log("checkedcheck", checkedCheckboxes);
    console.log("numberofgifts", parseInt(numberOfSelectableGifts));

    giftsStep.querySelectorAll("input[name=selected_product]:not(:checked").forEach((checkbox) => {


      console.log("checked", checkbox);
      console.log("ch", customProductId == checkbox.customProductId);

      var customProduct = giftsStep.querySelector(`#custom_product_${checkbox.dataset.customProductId}_preview_cart`);
      
      // if (customProductId == checkbox.customProductId) return;

      checkedCheckboxes == parseInt(numberOfSelectableGifts) ? customProduct.classList.add("select-none", "opacity-50") : customProduct.classList.remove("select-none", "opacity-50");

      checkbox.disabled = checkedCheckboxes == parseInt(numberOfSelectableGifts);



      

   
    })
  }

}